import { Alert, Box, Container } from "@mui/material";
import React, { useMemo, useState } from "react";
import BackBtn from "../../widgets/BackBtn";
import TopTitleActions from "../../widgets/TopTitleActions";
import { useParams } from "react-router-dom";
import useApiEp from "../../hooks/useApiEp";
import MuPb from "../../widgets/MuPb";
import { getErrorResponse, toastError } from "../../utils/util";
import ShowTextMessage from "./messages/ShowTextMessage";
import DialogSubmit from "./DialogSubmit";
import { API_ENDPOINT } from "../../utils/constants";
import { toast } from "react-toastify";
import ShowMediaMessage from "./messages/ShowMediaMessage";
import ShowInteractiveButtons from "./messages/ShowInteractiveButtons";
import ShowInteractiveCtaUrl from "./messages/ShowInteractiveCtaUrl";
import ShowInteractiveList from "./messages/ShowInteractiveList";
import ShowLocationMessage from "./messages/ShowLocationMessage";
import ShowEndpointMessage from "./messages/ShowEndpointMessage";
import ShowFormView from "./messages/ShowFormView";
import { template } from "lodash";
import ShowTemplateView from "./messages/ShowTemplateView";
export const messageComponentMap = {
  text: ShowTextMessage,
  location_request_message: ShowTextMessage,
  image: ShowMediaMessage,
  document: ShowMediaMessage,
  video: ShowMediaMessage,
  interactive_reply_buttons: ShowInteractiveButtons,
  interactive_cta_urls: ShowInteractiveCtaUrl,
  list: ShowInteractiveList,
  location: ShowLocationMessage,
  endpoint: ShowEndpointMessage,
  chatform: ShowFormView,
  template: ShowTemplateView,
};
const ChatBotDetail = () => {
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const { data, isLoading, isError, error, refetch } = useApiEp(
    `/message/get-response/${id}`
  );
  const MemoizedComponent = useMemo(() => {
    if (!data?.type) return null;
    const Component = messageComponentMap[data.type];
    return Component ? (
      <Component
        data={data}
        onOpen={() => {
          setOpen(true);
        }}
      />
    ) : null;
  }, [data]);
  if (isLoading) {
    return <MuPb />;
  }
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }
  return (
    <Container maxWidth="md" sx={{ mt: 3 }}>
      <BackBtn />
      <TopTitleActions title={"Chatbot Detail"} actions={[]} />
      <Box>{MemoizedComponent}</Box>
      <DialogSubmit
        open={open}
        onClose={() => setOpen(false)}
        inputLabel="Add trigger"
        endpoint={`${API_ENDPOINT}/message/add-trigger-text`}
        transformPayload={(text) => {
          return { triggerText: text, id: id };
        }}
        onSuccess={(data) => {
          toast.success(data.message);
          refetch();
        }}
        onError={(err) => {
          toastError(err);
        }}
      />
    </Container>
  );
};

export default ChatBotDetail;
